import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchRefunds, toggleRefundStatus } from "./refundsApi";

//Async thunk
export const fetchRefundsThunk = createAsyncThunk(
    "refunds/fetchRefunds",
    async (payload, { rejectWithValue, signal }) => {
        try {
            const res = await fetchRefunds(payload, signal);
            return res;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to fetch refunds");
        }
    }
);

export const toggleRefundStatusThunk = createAsyncThunk(
    "refund/toggleStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await toggleRefundStatus(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data || "Error marking order as refunded");
        }
    }
);